import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/components';
import i18n from '../../i18n/i18n';
import FlagIcon from '../../images/FlagIcon';
import RegionSelect from '@components/Miscellaneous/RegionSelect';
import LanguageSelect from '@components/Miscellaneous/LanguageSelect';
import { useLocale } from '@util/providers/Locale';

export default function RegionSelector({ className, mobile = false }) {
  const { locale } = useLocale();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={className}>
      <button
        onClick={() => setIsModalOpen(true)}
        data-testid={mobile ? 'MobileCurrencySelect' : 'CurrencySelect'}
        className="block cursor-pointer border-0 bg-transparent px-3 py-2 text-base text-info whitespace-nowrap hover:underline focus:outline-none"
      >
        <FlagIcon
          code={locale?.localeDetails?.isoCode?.toLowerCase()}
          className="mr-2 pr-2"
        />
        {i18n.language.toUpperCase()}
      </button>
      <RegionModal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} />
    </div>
  );
}

function RegionModal({ isOpen, toggle }) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {t('currencySelector.header')}
      </ModalHeader>
      <ModalBody className="px-8 py-6">
        <div className="grid grid-cols-12 gap-x-8 py-4">
          <div className="col-span-6">
            <div className="pb-2">{t('forms.country')}</div>
            <RegionSelect />
          </div>
          <div className="col-span-6">
            <div className="pb-2">{t('forms.language')}</div>
            <LanguageSelect />
          </div>
        </div>
        <div className="bg-light text-gray-600 p-6 mt-8">
          <p className="p-0 m-0" style={{ lineHeight: 1.25, fontSize: '75%' }}>
            {t('currencySelector.disclaimer.USD')}
          </p>
          <p className="pt-1 p-0 m-0" style={{ fontSize: '75%' }}>
            {t('partner.contactUs')}
            <a href={process.env.CONTACT_US} target="_blank" rel="noreferrer">
              {t('partner.contactCustomerService')}
            </a>
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          id="ContinueLocaleFooter"
          onClick={toggle}
          className="inline-block cursor-pointer select-none rounded border text-center align-middle leading-normal font-normal transition-colors duration-150 ease-in-out focus:outline-none disabled:pointer-events-none disabled:opacity-65 px-5 py-2.5 text-base border-primary bg-primary text-white hover:border-primary-hover hover:bg-primary-hover"
        >
          {t('action.continue')}
        </button>
      </ModalFooter>
    </Modal>
  );
}
